<template>
  <div class="order-details orderDetails" ref="container">
    <div class="receive-info">
      <p class="bor-b order-num">
        订单号：
        <span class="black">{{ orderInfo.order_id }}</span>
      </p>
      <!-- <p class="cusInfo">
        <span class="customer">{{orderInfo.customer_name}}</span>
        <span class="customer ml-20">{{orderInfo.customer_phone}}</span>
      </p>-->
      <div class="address-info">
        <p>
          <a>
            <span>单位：</span>
            <span class="ml-20 black">{{ orderInfo.customer_name }}</span>
          </a>
          <a>
            <span class="black">{{ orderInfo.consignee_name }}</span>
            <span class="ml-20 black">{{ orderInfo.consignee_phone }}</span>
          </a>
        </p>
        <p class="addr">
          <span>地址：</span>
          {{ orderInfo.consignee_address }}
        </p>
        <p class="addr">
          <span>备注：</span>
          {{ orderInfo.customer_mark }}
        </p>
      </div>
      <div class="line-box">
        <img src="@assets/images/line.jpg" />
        <p class="pro-count padding20 bor-b">
          <!-- <span>spu数：{{orderInfo.total_spu}}</span> -->
          <span>sku数：{{ orderInfo.total_sku }}</span>
          <span>商品数：{{ orderInfo.total_num }}</span>
        </p>
      </div>
    </div>
    <div class="info-box">
      <p style="padding:0.1rem;font-size: 0.26rem">费用：</p>
      <div class="price-info">
        <p>
          <a>
            商品价格:
            <span>¥{{ orderInfo.total_price * 1 }}</span>
          </a>
          +
          <a>
            运费:
            <span>¥{{ orderInfo.freight_price * 1 }}</span>
          </a>
          -
          <a>
            优惠金额:
            <span>¥{{ orderInfo.discount_price * 1 }}</span> </a
          >=
          <span class="under-line">¥{{ shouldPay * 1 }}</span>
        </p>
        <ul>
          <li>
            <span>余额支付</span>
            <span>{{ orderInfo.balance_pay_price * 1 }}</span>
          </li>
          <li>
            <span>线上支付</span>
            <span class="red"
              >{{ orderInfo.on_line_paid_price * 1 }}/{{
                orderInfo.on_line_pay_price * 1
              }}</span
            >
          </li>
          <li>
            <span>线下支付</span>
            <span class="red"
              >{{ orderInfo.offline_paid_price * 1 }}/{{
                orderInfo.offline_pay_price * 1
              }}</span
            >
          </li>
          <li>
            <span>物流代付</span>
            <span>{{ orderInfo.freight_pay_price * 1 }}</span>
          </li>
        </ul>
      </div>
      <div class="time-info mt-20">
        <p v-if="orderInfo.order_time">
          下单时间：{{ formdate(orderInfo.create_time) }}
        </p>
        <p v-if="orderInfo.pay_time">
          支付时间：{{ formdate(orderInfo.pay_time) }}
        </p>
        <p>物流公司：{{ orderInfo.freight_name }}</p>
        <!-- <p v-if="orderInfo.create_time">发货时间：{{formdate(orderInfo.create_time)}}</p> -->
      </div>
      <ul class="pro-list mt-20">
        <li
          class="proItem"
          v-for="(pro, index) in orderInfo.detail"
          :key="index"
        >
          <van-row class="pro-info">
            <van-col class="index" span="3">
              <span>{{ index / 1 + 1 }}</span>
            </van-col>
            <van-col span="20">{{
              pro.product_name + " " + pro.product_sn
            }}</van-col>
          </van-row>
          <van-row class="pro-con">
            <van-col span="4">
              <p class="pro-img">
                <img
                  style="vertical-align:center;"
                  :src="pro.image"
                  object-fit="cover"
                  alt
                />
              </p>
            </van-col>
            <van-col class="con-box" span="20">
              <p>
                <a class="pro-name">
                  颜色:
                  <span>{{ pro.colour }}</span>
                  <span class="ml-10"></span>
                  单价:
                  <span>{{ pro.price}}</span>
                  <span class="ml-10"></span>
                  数量:
                  <span>{{ pro.number }}</span>
                  <span class="ml-10"></span>
                  金额:
                  <span>{{ pro.total }}</span>
                </a>
              </p>
              <div class="size-box" :name="pro.item.length">
                <table cellpadding="0" cellspacing="0" border frame="box">
                  <thead>
                    <tr>
                      <th class="bg-gray"><p>尺码</p></th>
                      <th
                        class="bg-gray"
                        v-for="tip in pro.item[0]"
                        :key="tip.sku"
                      >
                        <p>{{ tip.size }}</p>
                      </th>
                    </tr>
                  </thead>
                  <tbody v-for="(item, index) in pro.item" :key="index">
                    <tr v-if="index !== 0">
                      <td class="bg-gray" v-for="tip in item" :key="tip.sku">
                        <p>{{ tip.size }}</p>
                      </td>
                    </tr>
                    <tr>
                      <td v-if="index === 0"><p>数量</p></td>
                      <td v-for="tip in item" :key="tip.sku">
                        <p>{{ tip.order_num }}</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </van-col>
          </van-row>
        </li>
      </ul>
    </div>
    <div style="height:1.2rem;"></div>
  </div>
</template>
<script>
import { isWeixin, formatPrice } from "@utils";
import { mapGetters } from "vuex";
import { getOrderAdminShow, confirmOrder, getPayInfo } from "@api/order";
export default {
  data() {
    return {
      sizeList: [{}],
      shouldPay: 0,
      unPay: "未支付金额：0.00",
      orderInfo: {
        add_time: "",
        consignee_address: null,
        consignee_name: null,
        consignee_phone: null,
        customer_id: "5",
        customer_mark: null,
        customer_name: "",
        customer_phone: "",
        detail: [],
        discount_price: "0.00",
        freight_name: "",
        freight_pay_price: null,
        freight_price: "0.00",
        freight_remarks: "",
        id: "",
        is_confirm: "0",
        offline_pay_price: "0.00",
        on_line_pay_price: "0.00",
        order_id: "",
        order_time: "",
        pay_status: "0",
        pay_time: null,
        pay_type: "0",
        status: "0",
        total_num: "0",
        total_pay_price: "0.00",
        total_price: "0.00",
        total_sku: "0",
        total_spu: "0"
      },
      confirmStaus: {
        1: "已确认",
        0: "未确认"
      },
      payType: {
        0: "余额支付",
        1: "线上支付",
        2: "线下支付",
        3: "物流代收"
      },
      payStatus: {
        0: "未支付",
        1: "部分支付",
        2: "已支付"
      },
      orderStatus: {
        0: "待支付",
        1: "已支付",
        2: "已发货",
        3: "完成",
        4: "关闭"
      },
      orderId: "",
      isShow: 1,
      token: ""
    };
  },
  created() {
    // console.log(this.$route);
    if (this.$route.params && this.$route.params.orderId) {
      this.orderId = this.$route.params.orderId;
      this.token = this.$route.params.token;
      if (this.$route.params.isShow) this.isShow = this.$route.params.isShow;
      // console.log(this.$route.params);
      this.getOrderDetal();
    }
    // this.getOrderDetal();
  },
  methods: {
    confirm() {
      confirmOrder(this.orderId)
        .then(res => {
          this.$dialog.toast({ mes: "确认成功" });
          this.$router.push({
            name: "orderList"
          });
        })
        .catch(err => {
          console.log(err);
        });
    },
    formdate(date) {
      var unixTimestamp = new Date(date * 1000);
      var commonTime = unixTimestamp.toLocaleString();
      var s = commonTime.toLocaleString();
      var ss = s.replace(/年|月/g, "-").replace(/日/g, " ");
      return ss;
    },
    getOrderDetal() {
      const { orderId, isShow, token } = this;
      getOrderAdminShow({ orderId, isShow, token: token })
        .then(res => {
          formatPrice(res.data);
          this.orderInfo = res.data;
          this.shouldPay = (
            res.data.total_price / 1 +
            res.data.freight_price / 1 -
            res.data.discount_price / 1
          ).toFixed(2);
          this.unPay =
            "未支付金额：" +
            (this.shouldPay - res.data.pay_price / 1).toFixed(2);
          // for(var i = 0;i<=9;i++) {
          //   res.data.detail[1].item.push(res.data.detail[1].item[0])
          // }
          const arr = res.data.detail;
          if (res.data.detail.length > 0) {
            for (var j = 0; j < arr.length; j++) {
              var result = [];
              let a = 7;
              for (var i = 0, len = arr[j].item.length; i < len; i += a) {
                a = i === 0 ? 7 : 8;
                result.push(arr[j].item.slice(i, i + a));
              }
              this.orderInfo.detail[j].item = result;
            }
          }
          this.orderInfo.order_time = this.formdate(res.data.order_time);
        })
        .catch(e => {
          console.log(e);
          this.$dialog.toast({ mes: e.msg });
          // this.orderInfo = e.data.data;
        });
    }
  },
  computed: {
    ...mapGetters(["userInfo"])
  }
};
</script>
<style>
.receive-info {
  background: white;
}
.order-num {
  padding: 0.1rem 0.2rem;
  color: #868686;
}
.address-info {
  display: flex;
  flex-direction: column;
  padding: 0.1rem 0.2rem;
}
.address-info p {
  color: #868686;
  padding: 0.1rem 0;
}
.address-info a {
  display: block;
  color: #868686;
}
.line-box {
  overflow: hidden;
}
.info-box {
  background: rgb(245, 245, 245);
  padding: 0 0.2rem;
}
.price-info,
.time-info,
.pro-list {
  background: white;
  border-radius: 5px;
}
.price-info p {
  padding: 0.2rem 0.1rem;
  border-bottom: 1px solid #ccc;
}
.price-info p a {
  border: 1px solid #ccc;
  font-size: 0.22rem;
  padding: 2px;
}
.price-info p span {
  font-size: 0.24rem;
  color: red;
}
.under-line {
  text-decoration-line: underline;
}
.price-info ul {
  display: flex;
  padding: 0.2rem 0;
  background: #fdf8fa;
}
.price-info li {
  width: 25%;
  display: flex;
  font-size: 0.26rem;
  flex-direction: column;
  text-align: center;
}
.price-info li span:nth-child(2) {
  margin-top: 0.1rem;
  color: #868686;
}
.price-info li span.red {
  color: red;
}
.time-info p {
  font-size: 0.26rem;
  color: #868686;
  padding: 0.1rem;
}
.pro-list {
  padding: 0.1rem;
}
.pro-info {
  font-weight: bold;
  font-size: 0.26rem;
  padding-top: 0.1rem;
}
.pro-info .index {
  text-align: center;
}
.pro-info .index span {
  border-radius: 50%;
  width: 0.3rem;
  height: 0.3rem;
  display: inline-block;
  vertical-align: middle;
  background: #ccc;
}
.proItem {
  border-bottom: 1px solid #ccc;
}
.pro-list .proItem:nth-last-child(1) {
  border-bottom: none;
}
.pro-con {
  display: flex;
  padding: 0.1rem;
}
.pro-con .pro-img {
  border-radius: 5px;
  padding: 0.1rem;
  overflow: hidden;
}
.pro-con .pro-img img {
  border-radius: 5px;
}
.con-box .tip {
  width: 20%;
}
.pay-box .van-cell {
  padding: 3px 16px;
}
.ml-10 {
  margin-left: 10px;
}
.black {
  color: #333;
}
table {
  border-color: #ccc;
}
.addr {
  font-size: 0.24rem;
}
tr td,
tr th {
  width: 12.5%;
}
td p,
th p {
  padding-left: 2px;
}
</style>
